module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-64745800-16","head":false,"anonymize":true,"respectDNT":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-facebook-pixel/gatsby-browser.js'),
      options: {"plugins":[],"pixelId":"314622409733128"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
